var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.show_widget)?_c('div',[_c('widget')],1):_vm._e(),_c('router-view'),_c('Toast',{attrs:{"position":"bottom-right"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }